import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/app/public/images/og_image_default.png");
;
import(/* webpackMode: "eager" */ "/app/src/components/AppDownloadSection/assets/mobilePhonePreview.png");
;
import(/* webpackMode: "eager", webpackExports: ["AppRatingSection"] */ "/app/src/components/AppRatingSection/AppRatingSection.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/Clickables/Buttons/AppStoreButtons/AppStoreButtons.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AppOnlyPill"] */ "/app/src/components/Clickables/Pill/AppOnlyPill.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/QRCode/QRCode.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CircleImage"] */ "/app/src/views/FeaturePages/components/CircleImage.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/views/FeaturePages/TopWatersPage/assets/phoneFour.png");
;
import(/* webpackMode: "eager" */ "/app/src/views/FeaturePages/TopWatersPage/assets/phoneOne.png");
;
import(/* webpackMode: "eager" */ "/app/src/views/FeaturePages/TopWatersPage/assets/phoneThree.png");
;
import(/* webpackMode: "eager" */ "/app/src/views/FeaturePages/TopWatersPage/assets/phoneTwo.png");
